import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { CAMPAIGN_SALES_PATHS } from "../CampaignSales/campaignSalesRoutes";
import { CANONICAL_SALES_PATH } from "../../constants/salesRoutes";

const EXCLUDED_PATHS = [CANONICAL_SALES_PATH, ...CAMPAIGN_SALES_PATHS];

const FloatingSubscribeButton = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { mySubscription } = useSelector((state) => state.globalReducer);
  const { userData } = useSelector((state) => state.userReducer);
  const isAuthenticated = !!userData?.firstName;

  const isExcludedPage = EXCLUDED_PATHS.some((path) =>
    location.pathname.startsWith(path)
  );

  if (isExcludedPage) return null;

  const hasActiveSubscription = mySubscription?.status === "ACTIVE";

  if (isAuthenticated && hasActiveSubscription) return null;

  return (
    <Link className="floating-subscribe-button" to={CANONICAL_SALES_PATH}>
      {t("subscription.floatingCta")}
    </Link>
  );
};

export default FloatingSubscribeButton;
